import React, {ReactNode, useMemo} from 'react';
import {LoadingButton} from "@mui/lab";
import {PropagateLoader} from "react-spinners";
import {LoadingButtonProps} from "@mui/lab/LoadingButton/LoadingButton";
import {theme} from "../../styles/Theme";
import {useTheme} from "@mui/material";

interface ThatsMeLoadingButtonProps extends LoadingButtonProps {
    children: ReactNode,
}

export const ThatsMeLoadingButton = (props: ThatsMeLoadingButtonProps) => {
    const {
        children,
        className, 
        loading, 
        disabled, 
        onClick, 
        fullWidth, 
        variant,
        ...rest
    } = props;
    const theme = useTheme();
    
    const propagateLoader = useMemo(() => {
        const colorMap = {
            primary: theme.palette.thatsMe.buttonLoading,
            primaryInvert: theme.palette.thatsMe.buttonInvertLoading,
            outlined: theme.palette.thatsMe.buttonSecondaryLoading,
            outlinedInvert: theme.palette.thatsMe.buttonSecondaryInvertLoading,
            default: theme.palette.thatsMe.buttonDefault,
        };

        const color = colorMap[variant as keyof typeof colorMap] || colorMap.default;
        
        return (
            <PropagateLoader className="loader" color={color} size={8}/>
        )
    }, []);
    
    return (
        <LoadingButton
            className={className} 
            onClick={onClick} 
            fullWidth={fullWidth} 
            disabled={disabled} 
            loading={loading}
            loadingIndicator={propagateLoader}
            variant={variant}
            {...rest}
        >
            {!loading && children}
        </LoadingButton>
    );
}